import vuewidget from './vuewidget'
import LastOrdersWidget from '@/pages/LastOrdersWidget.vue'

export default function (dom, opts) {
  // eslint-disable-next-line no-unused-vars
  const widget = vuewidget(dom, {
    vueComponent: LastOrdersWidget,
    ...opts
  })
}
